<template>
  <el-dialog title="Shipping Detail" :visible.sync="domVisible" width="480px" :lock-scroll="false" :before-close="handleClose">
    <div class="shipping_box">
      <el-scrollbar>
      <div  class="shippingScroll">
        <div v-for="(item,index) in list.Details" :key="index">
          <div class="cost_l color_333">
            <div class="locations color_333">{{item.ProvinceName}}</div>
            <span v-if="item.CostType==1">{{$t('base.payOnDelivery')}}</span>
            <span v-if="item.CostType!=1&&item.FreeDelivery&&item.DetailMinimumAmount<=0">{{$t('base.freeShipping')}}</span>
            <span v-if="item.CostType!=1&&item.FreeDelivery&&item.DetailMinimumAmount>0">{{areaSymbol}} {{formatAmount(item.Cost)}}</span>
            <span v-if="item.CostType!=1&&!item.FreeDelivery">{{areaSymbol}} {{formatAmount(item.Cost)}}</span>
            
          </div>
          <div class="cost_name">
          <span class="color_aoao address"></span>
          <span class="isFree" v-if="item.CostType!=1&&item.FreeDelivery&&item.DetailMinimumAmount>0">Free shipping on {{areaSymbol}} {{formatAmount(item.DetailMinimumAmount)}}+</span>
          </div>
        </div>
      </div>

      </el-scrollbar>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">{{ $t('base.done') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { formatAmount } from "@/api/public";
export default {
  name: '',
  data() {
    return {
    }
  },
  props: {
    domVisible: Boolean,
    list: {},
    areaSymbol:String
  },
  watch: {},
  filters: {},
  created() {
    //console.log(this.domVisible, 'domVisible')
    //console.log(this.list, 'list')
  },
  methods: {
    formatAmount(obj){
      return formatAmount(obj)
    },
    handleClose() {
      this.$emit('getDialog', false)
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/deep/ .el-dialog__body {
  padding: 12px 40px;
}
/deep/ .el-dialog__title{
  color: #333;
}
.shippingScroll{
  min-height:200px;
  max-height: 50vh;
  padding-right: 15px;
}
/* .shipping_box {
  padding: 12px 40px;
} */

.shipping_title {
  height: 18px;
  font-size: 16px;
}

.shipping_title_t {
  margin: 24px 0 0;
}

.shipping_cost {
  height: 18px;
  color: #f0ad4e;
  border: #f0ad4e 1px solid;
  border-radius: 3px;
  padding: 0 4px;
  margin: 0 0 0 8px;
}

.locations,
.cost_l span {
  height: 16px;
  margin: 16px 0 12px;
}

.color_aoao {
  min-height: 16px;
}

.address {
  display: block;
  /* margin-top: 16px; */
}

.international_s {
  margin-top: 16px;
}

.shipping_f {
  justify-content: space-between;
}

.shipping_f,
.ship_return,
.cost_l,.cost_name {
  display: flex;
}

.cost_l,.cost_name {
  justify-content: space-between;
}

.ship_return > div:first-child {
  width: 20%;
}

.ship_return > div:last-child {
  width: 80%;
}

.ship_return > div:last-child div {
  margin-bottom: 10px;
}

.ship_return .text_gray {
  font-size: 12px;
}

.ship_last_line {
  /* border-bottom: 1px solid #f0f0f0; */
  margin-bottom: 10px;
}

.ship_last_line2 {
  border-bottom: none;
}

.see {
  border-left: 1px solid;
  margin-left: 10px;
  padding-left: 10px;
}

.ship_return h5 {
  font-size: 24px;
}

.ship_return h5 .bids_box {
  font-size: 14px;
  font-weight: normal;
  margin-left: 25px;
  display: inline-block;
}

.line_last {
  padding: 0;
}

.no_line {
  border-bottom: none;
}

.Payments {
  height: 16px;
  display: block;
  background: url(../../../static/images/paypal2.png) no-repeat;
  background-size: 16.5%;
}
.isFree{
  color: #5F6DAE;
  padding: 4px 8px;
  border-radius: 4px;
  background: #F0F3FF;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/domesticstore.vue